<template>
    <div>
        <bo-cell-button-popup
            ref="bo-cell-button-popup"
            v-show="!hasItem || visible"
            :disabled="disabled || visible"
            :active="visible"
            @activate="setVisibility"
            @deactivate="setVisibility"
        >
            <template #button="slotProps">
                <slot v-if="!hasItem" name="button" v-bind="getProps(slotProps)"></slot>
            </template>
            <template #content="slotProps">
                <slot name="content" v-bind="getProps(slotProps)"></slot>
            </template>
        </bo-cell-button-popup>
        <div v-if="hasItem" style="display: contents">
            <slot name="item" :item="item"></slot>
            <span>
                <i v-if="!disabled" class="icon-edit cursor-pointer" @click="editItem"></i>
                <i v-if="!disabled" class="icon-arclight icon-deleteforever" @click="deleteItem"></i>
            </span>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        disabled: {
            type: Boolean,
            default: false,
        },
        item: {
            type: null,
        },
    },
    data() {
        return { visible: false };
    },
    computed: {
        hasItem: {
            get() {
                return this.item != null;
            },
        },
    },
    methods: {
        getProps(props) {
            return {
                default: this.default,
                ...props,
            };
        },
        deleteItem() {
            this.$emit("delete", this.item);
        },
        editItem() {
            this.setVisibility(true);
        },
        setVisibility(value) {
            this.visible = value;
        },
    },
};
</script>
